export default "__VITE_ASSET__CmCy7BiB__"